import { useEffect, useState } from "react"
import useErroPadrao from '../../../hooks/useErroPadrao';
import useHelp from '../../../hooks/useHelp';
import { useNavigate } from "react-router-dom";
import Dialog from '../../Layout/Dialog/Dialog';
import { CHAVE_TOKEN, real, linkWhatsApp } from "../../../utils/formata";

export default function EmpresaConsulta() {
    const [empresas, setEmpresas] = useState([]);
    const [busca, setBusca] = useState("");
    const [filtroCidade, setFiltroCidade] = useState("");
    const [carregando, setCarregando] = useState(true);
    const [idExcluir, setIdExcluir] = useState(null);
    const { consultarEmpresas, removerEmpresa } = useHelp();
    const { setErroPadrao } = useErroPadrao();
    const navigate = useNavigate();

    useEffect(() => {
        if (!!localStorage.getItem(CHAVE_TOKEN)) {
            consultarEmpresas()
                .then((data) => setEmpresas(data || []))
                .catch((error) => setErroPadrao(error))
                .finally(() => setCarregando(false));
        } else {
            navigate("/login");
        }
    }, [consultarEmpresas, setErroPadrao, navigate]);

    function handleExcluir() {
        removerEmpresa(idExcluir).then((status) => {
            if (status === 200) {
                setEmpresas(empresas.filter((e) => e.id !== idExcluir));
            }
        }).catch((error) => setErroPadrao(error));
    }

    // cidades presentes, com contagem, em ordem alfabética — pro dropdown
    const cidades = Object.entries(
        empresas.reduce((acc, e) => {
            const c = (e.cidade || "Sem cidade").trim();
            acc[c] = (acc[c] || 0) + 1;
            return acc;
        }, {})
    ).sort((a, b) => a[0].localeCompare(b[0], "pt-BR"));

    const filtradas = empresas
        .filter((e) => {
            const casaBusca = `${e.razaoSocial} ${e.nomeFantasia} ${e.cnpj} ${e.responsavel} ${e.cidade || ""}`.toLowerCase().includes(busca.toLowerCase());
            const casaCidade = !filtroCidade || (e.cidade || "Sem cidade").trim() === filtroCidade;
            return casaBusca && casaCidade;
        })
        // agrupa por cidade (mesma cidade junta, alfabético)
        .sort((a, b) => (a.cidade || "").localeCompare(b.cidade || "", "pt-BR") || (a.nomeFantasia || a.razaoSocial || "").localeCompare(b.nomeFantasia || b.razaoSocial || "", "pt-BR"));

    return (
        <div className="pagina">
            <div className="cabecalho-pagina">
                <h2 className="he-titulo">Empresas <span className="he-dourado">Clientes</span></h2>
                <button className="btn btn-he" onClick={() => navigate("/cadastro-empresa")}><i className="bi bi-plus-lg"></i> Nova Empresa</button>
            </div>

            <div style={{display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", margin: "1em 0"}}>
                <input className="form-control" style={{width: "100%", maxWidth: 360}} placeholder="Buscar por nome, CNPJ, responsável ou cidade..." value={busca} onChange={(e) => setBusca(e.target.value)}/>
                <select className="form-select" style={{width: "auto", maxWidth: 260}} value={filtroCidade} onChange={(e) => setFiltroCidade(e.target.value)} title="Filtrar por cidade">
                    <option value="">Todas as cidades ({empresas.length})</option>
                    {cidades.map(([c, q]) => <option key={c} value={c}>{c} ({q})</option>)}
                </select>
                {filtroCidade &&
                    <button className="btn btn-outline-he" onClick={() => setFiltroCidade("")}><i className="bi bi-x-lg"></i> {filtroCidade}</button>
                }
            </div>

            {carregando ? <div style={{textAlign: "center", padding: "2em"}}><span className="spinner-border" style={{color: "#d4af37"}}></span></div> :
            <div className="he-card sem-rolagem">
                <div className="tabela-rolavel rolagem-so-desktop">
                <table className="table table-striped table-hover tabela-responsiva">
                    <thead>
                        <tr>
                            <th>Cliente</th>
                            <th>CNPJ/CPF</th>
                            <th>Responsável</th>
                            <th>Telefone</th>
                            <th>Faturamento/mês</th>
                            <th style={{width: 160}}>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filtradas.map((e) => (
                            <tr key={e.id}>
                                <td className="principal" data-rotulo="Cliente" style={{fontWeight: 600}}>{e.tipoPessoa === "fisica" ? "👤 " : ""}{e.nomeFantasia || e.razaoSocial}<div style={{fontSize: "0.75em", color: "#9aa5b5", fontWeight: 400}}>{e.tipoPessoa === "fisica" ? "Pessoa Física" : e.razaoSocial}{e.cidade ? <> · <i className="bi bi-geo-alt" style={{color: "#d4af37"}}></i> {e.cidade}</> : ""}</div></td>
                                <td data-rotulo="CNPJ/CPF">{e.cnpj}</td>
                                <td data-rotulo="Responsável">{e.responsavel}</td>
                                <td data-rotulo="Telefone">{e.telefone}</td>
                                <td data-rotulo="Faturamento/mês">{e.faturamentoMensal ? real(e.faturamentoMensal) : "—"}</td>
                                <td className="acoes" data-rotulo="Ações">
                                    <div className="acoes-linha">
                                        <a className="btn btn-sm btn-success" title="WhatsApp" target="_blank" rel="noreferrer" href={linkWhatsApp(e.telefone, `Olá ${e.responsavel}! Aqui é da Help Empresarial. 😊`)}><i className="bi bi-whatsapp"></i><span className="so-mobile-inline"> WhatsApp</span></a>
                                        <button className="btn btn-sm btn-outline-he" title="Editar" onClick={() => navigate(`/cadastro-empresa?id=${e.id}`)}><i className="bi bi-pencil"></i><span className="so-mobile-inline"> Editar</span></button>
                                        <button className="btn btn-sm btn-danger largura-total" title="Excluir" onClick={() => setIdExcluir(e.id)} data-bs-toggle="modal" data-bs-target="#modal"><i className="bi bi-trash"></i><span className="so-mobile-inline"> Excluir</span></button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        {filtradas.length === 0 && <tr><td colSpan={6} style={{textAlign: "center", color: "#9aa5b5"}}>Nenhuma empresa encontrada.</td></tr>}
                    </tbody>
                </table>
                </div>
            </div>}

            <Dialog
                titulo="Excluir empresa"
                mensagem="Tem certeza? Todos os empréstimos e documentos dessa empresa serão excluídos junto."
                mensagemBotaoSim="Excluir"
                eventoBotaoSim={handleExcluir}
                abrir={idExcluir !== null}
                onFechar={() => setIdExcluir(null)}
            />
        </div>
    )
}
